const useIsLive = (): boolean => {
    const env = process.env;
    const publicURL = env.PUBLIC_URL;
    if (publicURL !== "https://webapp.missgoauction.com") return false;
    return true;
};

export default useIsLive;
